<template>
  <div class="share-list" :class="displayLayout">
    <div
      v-for="list in shareOptions"
      :key="list.id"
      :class="['share-item-options', list.className]"
      v-clipboard:copy="list.id === 'copyLink' ? copyText : ''"
      v-clipboard:success="list.id === 'copyLink' ? onCopySuccess : () => {}"
      v-clipboard:error="list.id === 'copyLink' ? onCopyError : () => {}"
      @click="share(list)"
    >
      <img
        v-lazy="list.icon"
        alt="share logo"
        :class="['share-item-logo', list.id]"
        :title="list.name"
      />
    </div>
  </div>
</template>
<script>
  // 分享列表
  // 注: 传入的参数和加工方法在mixins中
  import publicShareMobileMixins from '@/mixins/publicShareMobile'
  import { mapGetters } from 'vuex'

  export default {
    name: 'share-list',
    mixins: [publicShareMobileMixins],
    props: {},
    data() {
      return {}
    },
    computed: {
      ...mapGetters(['displayLayout']),
    },
    methods: {
      share(list) {
        this.goToShare(list)
      },
    },
  }
</script>
<style scoped lang="scss" src="./ShareList_pc.scss"></style>
<style lang="scss" scoped>
  .share-list.mobile-layout,
  .share-list.gt-layout {
    display: flex;
    flex-wrap: wrap;
    width: 820px;
    .share-item-options {
      &:not(:nth-child(5n)) {
        margin-right: 55px;
      }
      &:nth-child(n + 6) {
        margin-top: 60px;
      }
      .share-item-logo {
        width: 120px;
        height: 120px;
      }
    }
  }
</style>
